__webpack_require__.p = "/mag/";